<template>
  <CustomCreateDialog
    dialogTitle="افزودن استاد به کلاس گروهی"
    dialogId="assign-master-to-group-class-dialog"
    okTitle="افزودن"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendAssignMasterToGroupClassRequest"
  >
    <BCol cols="12" v-if="!selectedGroupClassId">
      <GroupClassPicker
        isInDialog
        @getGroupClass="setGroupClass"
      ></GroupClassPicker>
    </BCol>
    <BCol cols="12">
      <MasterPicker isInDialog @getMaster="setMasterUserId"></MasterPicker>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    selectedGroupClassId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      assignMasterToGroupClassPayload: {
        masterId: null,
        groupId: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setGroupClass(groupClass) {
      this.assignMasterToGroupClassPayload.groupId = groupClass.id;
    },
    setMasterUserId(master) {
      this.assignMasterToGroupClassPayload.masterId = master
        ? master.userId
        : null;
    },
    async sendAssignMasterToGroupClassRequest() {
      try {
        if (this.selectedGroupClassId) {
          this.assignMasterToGroupClassPayload.groupId =
            this.selectedGroupClassId;
        }
        this.isOkButtonDisabled = true;
        let _this = this;
        let assignMasterToGroupClass = new AssignMasterToGroupClass(_this);
        assignMasterToGroupClass.setRequestParam(
          _this.assignMasterToGroupClassPayload
        );
        await assignMasterToGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "افزوده شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "استادبا موفقیت به کلاس گروهی افزوده شد.",
              },
            });
            _this.assignMasterToGroupClassPayload = {
              masterId: null,
              groupId: null,
            };
            this.$bvModal.hide("assign-master-to-group-class-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "افزوده نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomCreateDialog,
    BCol,
    MasterPicker,
    GroupClassPicker,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import GroupClassPicker from "@/views/components/GroupClass/GroupClassPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { AssignMasterToGroupClass } from "@/libs/Api/GroupClass";
</script>
